/**
 * Admin Products Page
 * Manage SKUs and product variants
 */

import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ProductsSection } from '@ufc/domains/products'

export const Route = createFileRoute('/admin/products')({
  component: ProductsPage,
})

function ProductsPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          {t('products.title', 'Product Management')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('products.subtitle', 'Manage SKUs, variants, and product catalog')}
        </p>
      </div>
      <ProductsSection />
    </div>
  )
}
